import React, {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import CasesTable from '../components/cases/CasesTable';

import {useSmallScreen} from 'common/hooks/useScreenSize';
import Case, {CaseItem} from './Case';
import AdaptiveDrawer from 'common/components/AdaptiveDrawer';
import {Divider, Layout, Page} from '@phonectas/unifon-ui-kit';
import useBmoStore from 'common/stores/bmoStore';

const CasesTab: React.FC = () => {
	const location = useLocation();
	const isSmallScreen = useSmallScreen();
	const cases = useBmoStore((state) => state.ticketsList);
	const activeCaseId = useBmoStore((state) => state.ticketById?.id);

	const caseContent = useMemo(() => {
		return (
			location?.search !== '' && (
				<>
					<Layout direction="column" fullWidth nowrap>
						<Page.Section fullHeight>
							{
								cases && (
									<Case data={cases as CaseItem[]} />
								)
							}
						</Page.Section>
					</Layout>
				</>
			)
		);
	}, [cases, location?.search]);

	return (
		<Layout direction="row" nowrap fullHeight fullWidth style={{overflow: 'hidden'}}>
			<Layout direction="column" style={{minWidth: '65%'}} fullWidth nowrap>
				<Page.Section style={{overflow: 'hidden'}} fullHeight>
					{
						cases !== undefined && (
							<CasesTable />
						)
					}
				</Page.Section>
			</Layout>
			{
				activeCaseId !== undefined && (
					<Divider vertical dark />
				)
			}
			{
				isSmallScreen && activeCaseId !== undefined ?
					<AdaptiveDrawer setWidth={900}><>{caseContent}</></AdaptiveDrawer> :
					<>
						{caseContent}
					</>
			}
		</Layout>
	);
}

export default CasesTab;
